import React, { useCallback } from 'react';
import * as Styles from './StudioBottomBanner.styles';
import { GradientButton } from '@/pages/Studio/components';
import { IconAiPencil2 } from 'gatorcomponents';
import withErrorBoundary from '@/utils/errorBoundary';

const StudioBottomBanner = ({
  bannerAdLocale, trialAvailable, provisionFreePlan, handleShowModal, clickAdvertisingBottom, mobile,
}) => {
  const handleClick = useCallback(() => {
    clickAdvertisingBottom();

    if (trialAvailable) {
      handleShowModal(); return;
    }

    provisionFreePlan();
  }, [trialAvailable, provisionFreePlan, clickAdvertisingBottom, handleShowModal]);

  return (
    <Styles.BannerWrapper data-testid="studio-bottom-banner">
      <Styles.BannerContainer>
        <Styles.WrapperText>
          <Styles.Badge>{bannerAdLocale.badge}</Styles.Badge>
          <Styles.Title>
            {bannerAdLocale.title.bottom}
            <Styles.WrapperIcon>
              <IconAiPencil2
                color="highPure"
                secondaryColor="attentionPure"
                size={mobile ? 'sm' : 'md'}
                testId="myIconTestId"
              />
            </Styles.WrapperIcon>
          </Styles.Title>

          <Styles.WrapperButton>
            <GradientButton
              testId="upgrade-to-pro-button"
              label={bannerAdLocale.buttonLabel.bottom}
              onClick={() => handleClick()}
              size={mobile ? 'md' : 'lg'}
              variant="tertiary"
              width={mobile ? 'fit' : 'full'}
            />
          </Styles.WrapperButton>
        </Styles.WrapperText>
      </Styles.BannerContainer>
    </Styles.BannerWrapper>
  );
};

export default withErrorBoundary(StudioBottomBanner, 'StudioBottomBanner');
